// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__CreateBankAccountModal from "../../components/organisms/Manage/CreateBankAccountModal.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__Document from "../../grpc/Document.js";
import * as Buhta_cabinet__Dropdown from "../../components/html/Dropdown.js";
import * as Buhta_cabinet__Link from "../../components/html/Link.js";
import * as Buhta_cabinet__Org from "../../models/Org.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../components/molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../Route.js";
import * as Buhta_cabinet__ToastSender from "../../util/ToastSender.js";
import * as Buhta_cabinet__UpdateBankAccountModal from "../../components/organisms/Manage/UpdateBankAccountModal.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Buhta_core__Tenant from "../../../../../packages/core/lib/Tenant.js";
import * as Buhta_core__Toast from "../../../../../packages/core/lib/Toast.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as Formating from "../../../../../packages/util/lib/Formating.js";
import * as $$Promise from "../../../../../vendored/promise/promise.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function make(id) {
  return function (onDelete) {
    return function (onUpdate) {
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const activator = function (param) {
        return JsxRuntime.jsx("img", {
                    className: "w-6 h-6",
                    src: StaticAsset.src("/static/icons/more-gray-24.svg")
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  align: "BottomLeft",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: match[0],
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsxs("div", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        children: "Сделать основным"
                                      }),
                                  JsxRuntime.jsx("img", {
                                        className: "w-5 h-5",
                                        src: StaticAsset.src("/static/icons/star-gray-20.svg")
                                      })
                                ],
                                className: "flex justify-between px-4 hover:bg-gray-pale py-2"
                              }),
                          JsxRuntime.jsxs("button", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        children: "Редактировать"
                                      }),
                                  JsxRuntime.jsx("img", {
                                        className: "w-5 h-5",
                                        src: StaticAsset.src("/static/icons/edit-20.svg")
                                      })
                                ],
                                className: "flex justify-between px-4 hover:bg-gray-pale py-2",
                                onClick: (function (param) {
                                    Curry._1(setIsDropdownShown, (function (param) {
                                            return false;
                                          }));
                                    Curry._1(onUpdate, undefined);
                                  })
                              }),
                          JsxRuntime.jsx("hr", {
                                className: "my-1 mx-2"
                              }),
                          JsxRuntime.jsxs("button", {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                        children: "Удалить"
                                      }),
                                  JsxRuntime.jsx("img", {
                                        className: "w-5 h-5",
                                        src: StaticAsset.src("/static/icons/delete-red-20.svg")
                                      })
                                ],
                                className: "flex justify-between px-4 hover:bg-gray-pale py-2",
                                onClick: (function (param) {
                                    Curry._1(setIsDropdownShown, (function (param) {
                                            return false;
                                          }));
                                    Curry._1(onDelete, undefined);
                                  })
                              })
                        ],
                        className: "py-2 flex flex-col w-55"
                      })
                });
    };
  };
}

function ViewContractorPage$AccountDropdown(Props) {
  return Curry._1(make(Props.id)(Props.onDelete), Props.onUpdate);
}

const AccountDropdown = {
  make: ViewContractorPage$AccountDropdown
};

function make$1(org) {
  return function (id) {
    const match = Buhta_core__Tenant.useTenant(undefined);
    const tenant = match[0];
    const contextRoute = function (route) {
      return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
    };
    const match$1 = Buhta_core__Toast.ToastsContext.useToasts(undefined);
    const dispatchToasts = match$1[1];
    const match$2 = React.useState(function () {
          return /* General */0;
        });
    const setTab = match$2[1];
    const tab = match$2[0];
    const match$3 = React.useState(function () {
          return false;
        });
    const setShowModal = match$3[1];
    const match$4 = React.useState(function () {
          return false;
        });
    const setShowUpdateModal = match$4[1];
    const match$5 = React.useState(function () {
          
        });
    const setAccount = match$5[1];
    const account = match$5[0];
    const match$6 = React.useState(function () {
          return 1;
        });
    const setNonce = match$6[1];
    const nonce = match$6[0];
    const func = Buhta_cabinet__Document.ContractorService.view;
    const match$7 = Buhta_core__GrpcState.useModel((function (param) {
            return Curry._3(func, param, {
                        hd: "bank_accounts",
                        tl: {
                          hd: "default_bank_account",
                          tl: /* [] */0
                        }
                      }, id);
          }), undefined);
    const dispatch = match$7[1];
    const item = match$7[0];
    React.useEffect((function () {
            Curry._2(dispatch, undefined, undefined);
          }), [
          id,
          nonce
        ]);
    const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
          title: typeof item === "string" || item.NAME !== "Data" ? "Загрузка..." : item.VAL.name
        });
    const onDelete = function (contractor, id) {
      const __x = Buhta_cabinet__Document.ContractorBankAccountService.$$delete(tenant, contractor, id, undefined);
      $$Promise.get(__x, (function (result) {
              if (result.TAG !== /* Ok */0) {
                return Buhta_cabinet__ToastSender.sendGrpcErrorToast(dispatchToasts, result._0, "Ошибка при удалении");
              }
              Curry._1(setNonce, (function (param) {
                      return -nonce | 0;
                    }));
              Curry._1(dispatchToasts, {
                    TAG: /* Add */0,
                    _0: {
                      id: Buhta_core__Toast.generateId(undefined),
                      text: "Реквизиты успешно удалены",
                      kind: "success",
                      onClick: (function (param) {
                          
                        })
                    }
                  });
            }));
    };
    const bankAccounts = typeof item === "string" || item.NAME !== "Data" ? /* [] */0 : item.VAL.bank_accounts;
    const mainAccount = typeof item === "string" || item.NAME !== "Data" ? undefined : item.VAL.default_bank_account;
    let remainingAccounts;
    try {
      remainingAccounts = Stdlib__List.filter((function (acc) {
              if (mainAccount !== undefined) {
                return mainAccount.id !== acc.id;
              } else {
                return true;
              }
            }), bankAccounts);
    }
    catch (err){
      remainingAccounts = undefined;
    }
    let tmp;
    if (typeof item === "string" || item.NAME !== "Data") {
      tmp = null;
    } else {
      const data = item.VAL;
      tmp = JsxRuntime.jsxs(React.Fragment, {
            children: [
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.H1.make, {
                            children: data.name
                          }),
                      JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                            route: contextRoute({
                                  TAG: /* Manage */7,
                                  _0: /* Contractors */{
                                    _0: {
                                      TAG: /* Edit */1,
                                      _0: data.id
                                    }
                                  }
                                }),
                            children: tab === /* General */0 ? JsxRuntime.jsx("img", {
                                    className: "w-6 h-6",
                                    src: StaticAsset.src("/static/icons/edit-black-24.svg")
                                  }) : null
                          })
                    ],
                    className: "flex justify-between"
                  }),
              JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: tab === /* General */0 ? "text-links" : "text-gray-medium",
                                          children: "Информация"
                                        }),
                                    className: Cn.$plus("py-2.5", Cn.on("border-b border-links", tab === /* General */0)),
                                    onClick: (function (param) {
                                        Curry._1(setTab, (function (param) {
                                                return /* General */0;
                                              }));
                                      })
                                  }),
                              JsxRuntime.jsx("button", {
                                    children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                          className: tab === /* Accounts */1 ? "text-links" : "text-gray-medium",
                                          children: "Реквизиты"
                                        }),
                                    className: Cn.$plus("py-2.5", Cn.on("border-b border-links", tab === /* Accounts */1)),
                                    onClick: (function (param) {
                                        Curry._1(setTab, (function (param) {
                                                return /* Accounts */1;
                                              }));
                                      })
                                  })
                            ],
                            className: "flex gap-4"
                          }),
                      tab === /* Accounts */1 ? JsxRuntime.jsx("button", {
                              children: JsxRuntime.jsx("img", {
                                    className: "w-6 h-6",
                                    src: StaticAsset.src("/static/icons/plus-blue.svg")
                                  }),
                              onClick: (function (param) {
                                  Curry._1(setShowModal, (function (param) {
                                          return true;
                                        }));
                                })
                            }) : null
                    ],
                    className: "mt-6 border-b border-gray-main flex justify-between items-center"
                  }),
              tab ? JsxRuntime.jsxs(React.Fragment, {
                      children: [
                        mainAccount !== undefined ? JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                        className: "mt-6 text-default-gray",
                                        children: "Основной"
                                      }),
                                  JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                children: mainAccount.iban
                                              }),
                                          JsxRuntime.jsx(ViewContractorPage$AccountDropdown, {
                                                id: mainAccount.id,
                                                onDelete: (function (param) {
                                                    onDelete(data.id, mainAccount.id);
                                                  }),
                                                onUpdate: (function (param) {
                                                    Curry._1(setShowUpdateModal, (function (param) {
                                                            return true;
                                                          }));
                                                    Curry._1(setAccount, (function (param) {
                                                            return mainAccount;
                                                          }));
                                                  })
                                              })
                                        ],
                                        className: "py-1.5 mt-2 flex justify-between items-center"
                                      })
                                ]
                              }) : null,
                        remainingAccounts !== undefined ? JsxRuntime.jsxs(React.Fragment, {
                                children: [
                                  JsxRuntime.jsx(Buhta_components__Text.Label.make, {
                                        className: "mt-6 text-default-gray",
                                        children: "Дополнительные"
                                      }),
                                  Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(remainingAccounts, (function (index, a) {
                                              const Key = String(index);
                                              return JsxRuntime.jsxs("div", {
                                                          children: [
                                                            JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                                  children: a.iban
                                                                }),
                                                            JsxRuntime.jsx(ViewContractorPage$AccountDropdown, {
                                                                  id: a.id,
                                                                  onDelete: (function (param) {
                                                                      onDelete(data.id, a.id);
                                                                    }),
                                                                  onUpdate: (function (param) {
                                                                      Curry._1(setShowUpdateModal, (function (param) {
                                                                              return true;
                                                                            }));
                                                                      Curry._1(setAccount, (function (param) {
                                                                              return a;
                                                                            }));
                                                                    })
                                                                })
                                                          ],
                                                          className: "py-1.5 mt-2 flex justify-between items-center"
                                                        }, Key);
                                            })))
                                ]
                              }) : null
                      ]
                    }) : JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "ИИН / БИН"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.tin
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Тип"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: Buhta_cabinet__Org.Type.toString(data["type'"])
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Юр. адрес"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.legal_address
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Фактический адрес"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.real_address
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Номер телефона"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: Formating.formatPhone(data.phone)
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Почта"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.email
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Руководитель"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.chief_family_name + (" " + (data.chief_given_name + (" " + data.chief_patronymic_name)))
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              className: "text-gray-medium",
                              children: "Позиция"
                            }),
                        JsxRuntime.jsx(Buhta_components__Text.P.make, {
                              className: "col-span-2",
                              children: data.chief_position
                            })
                      ],
                      className: "mt-6 grid grid-cols-3 gap-x-4 gap-y-2 items-center"
                    }),
              JsxRuntime.jsxs("button", {
                    children: [
                      JsxRuntime.jsx(Buhta_components__Text.H4.make, {
                            children: "Создать Акт сверки"
                          }),
                      JsxRuntime.jsx("img", {
                            className: "w-6 h-6",
                            src: StaticAsset.src("/static/icons/docs-black-24.svg")
                          })
                    ],
                    className: "flex gap-3 w-full border border-gray-main rounded justify-center py-3 mt-6"
                  }),
              match$3[0] ? JsxRuntime.jsx(Buhta_cabinet__CreateBankAccountModal.make, {
                      onClose: (function (created) {
                          Curry._1(setShowModal, (function (param) {
                                  return false;
                                }));
                          if (created) {
                            return Curry._1(setNonce, (function (param) {
                                          return -nonce | 0;
                                        }));
                          }
                          
                        }),
                      contractor: data.id
                    }) : null,
              match$4[0] && account !== undefined ? JsxRuntime.jsx(Buhta_cabinet__UpdateBankAccountModal.make, {
                      onClose: (function (updated) {
                          Curry._1(setShowUpdateModal, (function (param) {
                                  return false;
                                }));
                          if (updated) {
                            return Curry._1(setNonce, (function (param) {
                                          return -nonce | 0;
                                        }));
                          }
                          
                        }),
                      contractor: data.id,
                      data: account
                    }) : null
            ]
          });
    }
    return JsxRuntime.jsx(Buhta_cabinet__DashboardContentTemplate.make, {
                header: header,
                children: JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_cabinet__Link.make, {
                                    route: contextRoute({
                                          TAG: /* Manage */7,
                                          _0: /* Contractors */{
                                            _0: /* List */0
                                          }
                                        }),
                                    children: JsxRuntime.jsx("img", {
                                          className: "w-5 h-5",
                                          src: StaticAsset.src("/static/icons/close-20.svg")
                                        })
                                  }),
                              className: "bg-white py-4.5 px-6 border-b border-gray-main w-full flex"
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp,
                              className: "w-140.5 shadow-card p-10 bg-white mt-10 rounded-md"
                            })
                      ],
                      className: "w-full flex flex-col items-center bg-gray-pale overflow-y-auto pb-10"
                    })
              });
  };
}

function ViewContractorPage(Props) {
  return make$1(Props.org)(Props.id);
}

const make$2 = ViewContractorPage;

export {
  AccountDropdown ,
  make$2 as make,
}
/* Buhta_cabinet__CreateBankAccountModal Not a pure module */
